import { Component, OnInit, Input, ViewChild, OnDestroy } from '@angular/core';
import { Observable, SubscriptionLike } from 'rxjs';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
  AbstractControl,
} from '@angular/forms';
import { PlanogramBaseDetailInfo } from 'src/modals/planogram';
import { MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { CONFIG } from '../../helper/app-config';
import { PlanogramNewBuilderComponent } from '../planogram-new-builder/planogram-new-builder.component';
@Component({
  selector: 'app-admin-custom-planogram',
  templateUrl: './admin-custom-planogram.component.html',
  styleUrl: './admin-custom-planogram.component.css',
})
export class AdminCustomPlanogramComponent implements OnInit, OnDestroy {
  @ViewChild(PlanogramNewBuilderComponent)
  planogramNewBuilderComponent!: PlanogramNewBuilderComponent;
  planogram_created: boolean = false;
  admin_custom_plano_stepper_index: number = 0;
  isReset: boolean = false;
  planogram_id: any = '';
  planogram_create_custom_planogram_form_group: any;
  channels: string[] = [];
  coolers: string[] = [];
  units: string[] = [];
  temp_npd_data: any = undefined;
  planogram_name: string = '';
  npd_data_subscription: SubscriptionLike;
  planogram_base_details_subscription: SubscriptionLike;
  planogram_base_details: Observable<PlanogramBaseDetailInfo> =
    this.planogramState.planogram_base_details;
  temp_planogram_base_details: PlanogramBaseDetailInfo = {};
  planogram_name_error: Observable<string> =
    this.planogramState.planogram_name_error;
  npd_data_with_facings: any = [];
  npds_max_message: string = '';
  selected_planogram_base_data_subscription: SubscriptionLike;
  selected_planogram_base_data: Observable<Object> =
    this.planogramState.selected_planogram_base_data;
  maximum_npds_allowed: number;
  isValidPlan: boolean = false;
  npd_data: Observable<Object> = this.planogramState.npd_data;
  is_show_loader: Observable<boolean> = this.planogramState.loader;
  save: boolean = false;
  constructor(
    private planogramState: PlanogramStateService,
    private _formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.planogramState.getBaseData();
    let planogram_name = '',
      planogram_name_disable = false,
      channel = '',
      units = '',
      cooler_type = '';
    this.planogram_create_custom_planogram_form_group = this._formBuilder.group(
      {
        planogram_name: new FormControl(
          { value: planogram_name, disabled: planogram_name_disable },
          [Validators.required, Validators.pattern(/^[A-Za-z0-9_]+$/)]
        ),
        channel: new FormControl(
          { value: channel, disabled: true },
          Validators.required
        ),
        units: new FormControl(
          { value: units, disabled: true },
          Validators.required
        ),
        cooler_type: new FormControl(
          { value: cooler_type, disabled: true },
          Validators.required
        ),
      }
    );
    let planogram_id;
    this.activatedRoute.params.subscribe((params) => {
      planogram_id = params['planogram_id'];
      if (planogram_id !== undefined && planogram_id !== -1) {
        this.planogram_id = planogram_id;
        this.planogramState.setPlanogramEdit(true, planogram_id);
      }
    });

    const router_state = this.router.getCurrentNavigation()?.extras.state;
    if (router_state) {
      this.admin_custom_plano_stepper_index = router_state['screen_index']
        ? router_state['screen_index']
        : this.admin_custom_plano_stepper_index;
    }
    // else if (
    //   planogram_id &&
    //   localStorage.getItem('admin_custom_plano_stepper_index')
    // ) {
    //   this.admin_custom_plano_stepper_index = Number(
    //     localStorage.getItem('admin_custom_plano_stepper_index')
    //   );
    // }
    // localStorage.setItem(
    //   'admin_custom_plano_stepper_index',
    //   String(this.admin_custom_plano_stepper_index)
    // );
  }

  ngOnInit(): void {
    this.planogram_create_custom_planogram_form_group.controls[
      'units'
    ]?.setValue('');
    this.planogram_create_custom_planogram_form_group.controls[
      'channel'
    ]?.setValue('');
    this.planogram_create_custom_planogram_form_group.controls[
      'cooler_type'
    ]?.setValue('');
    this.planogram_create_custom_planogram_form_group.controls[
      'planogram_name'
    ]?.setValue('');
    this.npd_data_with_facings = {};
    // this.temp_npd_data.maximum_facings;
    // this.temp_npd_data.maximum_facings;
    this.subscribeFormControls();
    this.selectedPlanogramBaseDataSubscription();
  }

  ngOnDestroy(): void {
    this.planogram_base_details_subscription.unsubscribe();
    this.selected_planogram_base_data_subscription.unsubscribe();
  }

  isRequiredField = (field: string) => {
    const form_field = this.planogram_create_custom_planogram_form_group.get(
      field
    ) as AbstractControl;
    if (!form_field.validator) {
      return false;
    }

    const validator = form_field.validator({} as AbstractControl);
    return validator && validator['required'];
  };

  onBlurPlanogramName = () => {
    let planogram_name = this.planogram_create_custom_planogram_form_group
      .get('planogram_name')
      ?.value.trim();
    if (
      this.planogram_create_custom_planogram_form_group.get('planogram_name')
        ?.valid
    ) {
      this.planogramState.verifyPlanogramUniqueName(planogram_name);
    }
  };

  subscribeFormControls = () => {
    this.planogram_base_details_subscription =
      this.planogram_base_details.subscribe((p_b_d) => {
        this.temp_planogram_base_details = p_b_d;
        if (p_b_d && Object.keys(p_b_d).length > 0) {
          this.units = Object.keys(p_b_d);
          if (this.units && this.units.length > 0) {
            this.planogram_create_custom_planogram_form_group.controls[
              'units'
            ].enable();
          }
          this.channels = Object.keys(p_b_d[this.units[0]]);
          // if(this.channels && this.channels.length>0){
          //   this.planogram_base_detail_form_group.controls['channel'].enable();
          // }
          this.coolers = p_b_d[this.units[0]][this.channels[0]];
          // if(this.coolers && this.coolers.length>0){
          //   this.planogram_base_detail_form_group.controls['cooler_type'].enable();
          // }
        }
      });
  };

  clearSelectionOnValueChange = (_event: any, form_control_name: string) => {
    this.planogram_create_custom_planogram_form_group
      .get(form_control_name)
      ?.setValue('');
    this.planogram_create_custom_planogram_form_group
      .get('cooler_type')
      ?.setValue('');
    // if (!this.channels)
    this.planogram_create_custom_planogram_form_group.controls[
      'channel'
    ].enable();
    this.channels = Object.keys(
      this.temp_planogram_base_details[
        this.planogram_create_custom_planogram_form_group.controls['units']
          .value
      ]
    );
  };

  handleChannelChange = (event: MatSelectChange) => {
    localStorage.setItem('channel', event.source.triggerValue);
    this.planogram_create_custom_planogram_form_group
      .get('cooler_type')
      ?.setValue('');
    // if (!this.coolers) {
    this.planogram_create_custom_planogram_form_group.controls[
      'cooler_type'
    ].enable();
    // }
    this.coolers =
      this.temp_planogram_base_details[
        this.planogram_create_custom_planogram_form_group.controls[
          'units'
        ].value
      ][
        this.planogram_create_custom_planogram_form_group.controls[
          'channel'
        ].value
      ];
  };

  clearSelectedCoolerInfo() {
    this.getNPDData();
  }

  getNPDData() {
    let selectedUnit: string =
      this.planogram_create_custom_planogram_form_group.controls['units'].value;
    let selectedChannel: string =
      this.planogram_create_custom_planogram_form_group.controls['channel']
        .value;
    let selectedCooler: string =
      this.planogram_create_custom_planogram_form_group.controls['cooler_type']
        .value;
    let body_params = {
      channel: selectedChannel,
      cooler_type: selectedCooler,
      unit: selectedUnit,
    };
    this.planogramState.getBaseNPDData(body_params);
    this.subscribeNPDData();
  }

  subscribeNPDData = () => {
    this.npd_data_subscription = this.npd_data.subscribe((data: any) => {
      if (data.data) {
        let npds = data.data.NPDs;
        for (let i = 0; i < npds.length; i++) {
          npds[i].facings = 0;
        }
        this.temp_npd_data = data.data;
        this.npd_data_with_facings = npds;
        let selected_cooler =
          this.planogram_create_custom_planogram_form_group.controls[
            'cooler_type'
          ].value.trim();
        this.maximum_npds_allowed = data.data.maximum_facings;
        this.npds_max_message = `${this.maximum_npds_allowed} NPD facing allowed`;
        this.checkNpdsMinAndMax();
      }
    });
  };

  checkNpdsMinAndMax() {
    this.isValidPlan = true;
    let minumumRequired = this.temp_npd_data.minimum_facings;
    let maximumPresent = 0;
    let npdsLength = this.npd_data_with_facings.length;
    for (let i = 0; i < npdsLength; i++) {
      let value = this.npd_data_with_facings[i].facings;
      if (value) maximumPresent += value;
      if (value !== 0 && value < minumumRequired) this.isValidPlan = false;
    }
    if (
      maximumPresent > this.maximum_npds_allowed ||
      maximumPresent < this.maximum_npds_allowed
    )
      this.isValidPlan = false;
    console.log('is Valid', this.isValidPlan);
  }

  showToolTip(name: string) {
    if (name.length > 28) {
      return true;
    } else return false;
  }

  truncateNPDName(name: string) {
    if (name.length > 28) {
      return name.slice(0, 28) + '..';
    } else return name;
  }

  decrement(i: number, key: string): void {
    this.npd_data_with_facings = this.npd_data_with_facings.map(
      (n: any, index: number) => {
        if (i == index && n.facings >= 1) {
          n.facings--;
        }
        return n;
      }
    );
    this.checkNpdsMinAndMax();
  }

  increment(i: number, key: string): void {
    this.npd_data_with_facings = this.npd_data_with_facings.map(
      (n: any, index: number) => {
        if (i == index) {
          n.facings++;
        }
        return n;
      }
    );
    this.checkNpdsMinAndMax();
  }

  createCustomPlanogram() {
    let selectedUnit: string =
      this.planogram_create_custom_planogram_form_group.controls['units'].value;
    let selectedChannel: string =
      this.planogram_create_custom_planogram_form_group.controls['channel']
        .value;
    let selectedCooler: string =
      this.planogram_create_custom_planogram_form_group.controls['cooler_type']
        .value;
    let planogram_name: string =
      this.planogram_create_custom_planogram_form_group.controls[
        'planogram_name'
      ].value;
    let payload: any = {
      planogram_name: planogram_name,
      channel: selectedChannel,
      unit: selectedUnit,
      cooler_type: selectedCooler,
    };
    payload['NPDs'] = this.npd_data_with_facings;
    payload.min_facings = this.temp_npd_data.minimum_facings;
    payload.max_facings = this.temp_npd_data.maximum_facings;
    console.log('npd', this.npd_data_with_facings);
    this.planogramState.createCustomPlanogram(payload);
    this.admin_custom_plano_stepper_index = 1;
    localStorage.setItem('admin_custom_plano_stepper_index', '1');
    this.planogram_created = true;
  }

  moveToCustomPlanogramLibrary() {
    this.router.navigateByUrl(CONFIG.PATH.CUSTOM_PLANOGRAM_LIBRARY);
  }

  // setStepperIndex(event: any) {
  //   console.log('event', event);
  //   this.admin_custom_plano_stepper_index = event.selectedIndex;
  //   localStorage.setItem(
  //     'admin_custom_plano_stepper_index',
  //     String(this.admin_custom_plano_stepper_index)
  //   );
  // }

  resetPlanogram(event: any) {
    this.isReset = event.reset;
  }

  reset() {
    this.isReset = true;
  }

  moveToLibrary() {
    this.router.navigateByUrl(CONFIG.PATH.LANDING_PAGE);
  }

  selectedPlanogramBaseDataSubscription = () => {
    this.selected_planogram_base_data_subscription =
      this.selected_planogram_base_data.subscribe((data: any) => {
        if (this.planogram_id) {
          if (data.name) {
            localStorage.setItem('channel', data.channel);
            this.planogram_create_custom_planogram_form_group
              .get('planogram_name')
              ?.setValue(data.name);
            this.planogram_create_custom_planogram_form_group
              .get('planogram_name')
              ?.disable();
            this.planogram_create_custom_planogram_form_group
              .get('channel')
              ?.setValue(data.channel);
            this.planogram_create_custom_planogram_form_group
              .get('channel')
              ?.enable();
            this.planogram_create_custom_planogram_form_group
              .get('units')
              ?.setValue(data.unit);
            this.planogram_create_custom_planogram_form_group
              .get('cooler_type')
              ?.setValue(data.cooler_type);
            this.planogram_create_custom_planogram_form_group
              .get('cooler_type')
              ?.enable();
            this.temp_npd_data = data.NPDs;
            this.npd_data_with_facings = data.NPDs.NPDs;
            this.maximum_npds_allowed =
              data.NPDs.max_facings || data.NPDs.maximum_facings;
            this.npds_max_message = `${
              this.maximum_npds_allowed || ''
            } NPD facing allowed`;
            // this.getRequriedDataForSpecificScreen(
            //   data.screen_id - 1,
            //   data.id,
            //   data.channel
            // );
          }
        }
      });
  };

  goBack() {
    if (this.admin_custom_plano_stepper_index == 1) {
      this.admin_custom_plano_stepper_index = 0;
      localStorage.setItem('this.admin_custom_plano_stepper_index', '0');
    }
  }

  saveAndPublish() {
    // this.save = true;
    this.planogramNewBuilderComponent.saveCustomizedPlanogram();
  }
}
